// extracted by mini-css-extract-plugin
export default {"table":"InterviewsTable-module__table__O6VgT","button":"InterviewsTable-module__button__TrFRC"};